/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechScreenTabletVIcon16Light } from './TechScreenTabletVIcon16Light';
import { TechScreenTabletVIcon16Regular } from './TechScreenTabletVIcon16Regular';
import { TechScreenTabletVIcon16Solid } from './TechScreenTabletVIcon16Solid';
import { TechScreenTabletVIcon20Light } from './TechScreenTabletVIcon20Light';
import { TechScreenTabletVIcon20Regular } from './TechScreenTabletVIcon20Regular';
import { TechScreenTabletVIcon20Solid } from './TechScreenTabletVIcon20Solid';
import { TechScreenTabletVIcon24Regular } from './TechScreenTabletVIcon24Regular';
import { TechScreenTabletVIcon24Solid } from './TechScreenTabletVIcon24Solid';
import { TechScreenTabletVIcon32Regular } from './TechScreenTabletVIcon32Regular';
import { TechScreenTabletVIcon64Regular } from './TechScreenTabletVIcon64Regular';
var sizes = {
    16: {
        light: TechScreenTabletVIcon16Light,
        regular: TechScreenTabletVIcon16Regular,
        solid: TechScreenTabletVIcon16Solid,
    },
    20: {
        light: TechScreenTabletVIcon20Light,
        regular: TechScreenTabletVIcon20Regular,
        solid: TechScreenTabletVIcon20Solid,
    },
    24: {
        regular: TechScreenTabletVIcon24Regular,
        solid: TechScreenTabletVIcon24Solid,
    },
    32: {
        regular: TechScreenTabletVIcon32Regular,
    },
    64: {
        regular: TechScreenTabletVIcon64Regular,
    },
};
export var TechScreenTabletVIcon = forwardRef('TechScreenTabletVIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
